// comps
import Layout from './layout/Layout.vue'
import Row from './layout/Row/Row.vue'
import Col from './layout/Col/Col.vue'

import Avatar from './Avatar.vue'
import Alert from './Alert.vue'
import Btn from './Btn.vue'
import Chip from './Chip.vue'
import ChipGroup from './ChipGroup.vue'
import Icon from './Icon.vue'
import Menu from './Menu.vue'
import List from './List.vue'
import ListItem from './ListItem.vue'
import CollapseItem from './CollapseItem.vue'
import Spacer from './Spacer.vue'
import Toolbar from './Toolbar.vue'
import Card from './Card.vue'
import Figure from './media/FigureComp.vue'
import Loader from './Loader.vue'
import Drawer from './Drawer.vue'
import BottomNavigation from './BottomNavigation.vue'
import TopNavigation from './TopNavigation.vue'
import Stepper from './Stepper.vue'
import Title from './Title.vue'
import Divider from './Divider.vue'
import Modal from './Modal.vue'
import Carousel from './Carousel.vue'

import Form from './form/Form'
import BxsSwitchField from './form/BxsSwitchField.vue'
import BxsTextField from './form/TextField.vue'
import BxsTextareaField from './form/BxsTextareaField.vue'
import BxsNumberField from './form/BxsNumberField.vue'
import BxsFileUploader from './FileUploader.vue'

import DataLazy from './DataLazy.vue'

import Logo from './Logo.vue'

//
import WorkCassaField from './project/WorkCassaField.vue'
import LatestEditWorks from './project/sections/LatestEditWorks.vue'
import LatestWorks from './project/sections/LatestWorks.vue'
import WorkRow from './project/WorkRow.vue'

// libs
import { DatePicker } from 'v-calendar'
import Toast from 'vue-toastification'
import VueEasyLightbox from 'vue-easy-lightbox'
import stickybits from 'stickybits'

import 'v-calendar/dist/style.css'
import 'vue-toastification/dist/index.css'

export default function createComp(app) {
    app.component('logo', Logo)

    app.component('bxs-layout', Layout)
    app.component('bxs-row', Row)
    app.component('bxs-col', Col)

    app.component('bxs-toolbar', Toolbar)
    app.component('bxs-bottom-nav', BottomNavigation)
    app.component('bxs-top-nav', TopNavigation)
    app.component('bxs-stepper', Stepper)
    app.component('bxs-divider', Divider)
    app.component('bxs-modal', Modal)
    app.component('bxs-carousel', Carousel)

    app.component('bxs-avatar', Avatar)
    app.component('bxs-card', Card)
    app.component('bxs-data-lazy', DataLazy)
    app.component('bxs-figure', Figure)

    app.component('bxs-btn', Btn)
    app.component('bxs-menu', Menu)
    app.component('bxs-drawer', Drawer)
    app.component('bxs-list', List)
    app.component('bxs-list-item', ListItem)
    app.component('bxs-collapse-item', CollapseItem)

    app.component('bxs-icon', Icon)
    app.component('bxs-chip', Chip)
    app.component('bxs-chip-group', ChipGroup)
    app.component('bxs-loader', Loader)

    app.component('bxs-form', Form)
    app.component('bxs-switch-field', BxsSwitchField)
    app.component('bxs-text-field', BxsTextField)
    app.component('bxs-textarea-field', BxsTextareaField)
    app.component('bxs-number-field', BxsNumberField)
    app.component('bxs-file-uploader', BxsFileUploader)
    app.component('bxs-date-picker', DatePicker)

    app.component('bxs-spacer', Spacer)
    app.component('bxs-alert', Alert)
    app.component('bxs-title', Title)

    // ---
    app.component('section-latest-edit-works', LatestEditWorks)
    app.component('section-latest-works', LatestWorks)
    app.component('work-row', WorkRow)
    app.component('work-cassa-field', WorkCassaField)

    app.use(Toast, {
        position: 'top-center',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        newestOnTop: false,
        transition: 'Vue-Toastification__fade',
        bodyClassName: ['bxs-notify'],
        maxToasts: 1,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        draggable: false
    })

    app.use(VueEasyLightbox)

    app.config.globalProperties.$sticky = stickybits
}